import axios from "axios";
import { handleUnauthorized } from "./session401";

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_API_CONNECTION}`,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json"
  },
});

Axios.defaults.headers.common["content-type"] = "application/json";
Axios.defaults.headers.common["application"] = "web";
Axios.defaults.headers.common["x-app"] = "web";

// Interceptor para agregar el token en cada request
Axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta mejorado
Axios.interceptors.response.use(
  (response) => {
    // Manejo especial para 304 (Not Modified)
    if (response.status === 304) {
      console.log("Received 304 - using cached data");
      // Para 304, mantenemos la respuesta pero con status 200
      // El navegador ya tiene los datos en cache
      response.status = 200;
    }
    return response;
  },
  (error) => {
    // Detectar errores de CORS antes de otros errores
    // Los errores de CORS generalmente no tienen response y tienen código 0 o ERR_NETWORK
    const isCorsError = (!error.response && error.request) || 
                       (error.response && error.response.status === 0) ||
                       (error.message && (
                         error.message.toLowerCase().includes('cors') || 
                         error.message.toLowerCase().includes('network error') ||
                         error.message.toLowerCase().includes('access-control-allow-origin')
                       )) ||
                       error.code === 'ERR_NETWORK' ||
                       error.code === 'ERR_CORS';
    
    if (isCorsError) {
      // Marcar el error como CORS para manejo especial
      error.isCorsError = true;
      error.corsSilent = true;
      // No loguear errores de CORS en consola para evitar ruido
      // El errorHandler lo manejará si es necesario
    }
    
    // 401: distinguir "sesión expirada de verdad" (token vencido y refresh
    // fallido → logout deduplicado) de un 401 puntual de un endpoint con token
    // vigente (se propaga a la vista sin matar la sesión). Ver session401.js.
    if (error.response && error.response.status === 401) {
      return handleUnauthorized(error, Axios);
    }
    
    return Promise.reject(error);
  }
);

export default Axios;